/**
 * Formats an ISO timestamp as `d.m.Y HH:mm` in Europe/Bucharest (24h, no
 * seconds). Uses two locale-formatters so we get the exact `.` separators
 * without pulling in a date library.
 *
 * Returns `—` for null / invalid input so callers can drop it straight
 * into JSX without defensive checks.
 */
export const formatBucharestDateTime = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const dateStr = date.toLocaleDateString('ro-RO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Bucharest',
  });
  const timeStr = date.toLocaleTimeString('ro-RO', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Europe/Bucharest',
  });
  return `${dateStr} ${timeStr}`;
};
